import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=4e3cd299&scoped=true&"
import script from "./ResourceDetail.vue?vue&type=script&lang=js&"
export * from "./ResourceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=4e3cd299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cd299",
  null
  
)

export default component.exports